import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Admin from './pages/admin';
import AdminLayout from './pages/AdminLayout';
import AfisOlustur from './pages/AfisOlustur';
import BlogDuzenle from './pages/BlogDuzenle';
import BlogEkle from './pages/BlogEkle';
import KategoriEkle from './pages/KategoriEkle';
import KullaniciDuzenle from './pages/KullaniciDuzenle';
import KullaniciEkle from './pages/KullaniciEkle';
import Login from './pages/login';
import AfisDuzenle from './pages/AfisDuzenle';
import PortfolyoEkle from "./pages/PortfolyoEkle";
import WorkHoursPanel from './pages/WorkHoursPanel';
import YemekListesiEkle from './pages/YemekListesiEkle';
import YemekListesiDuzenle from './pages/YemekListesiDuzenle';
import VideoEntryForm from './pages/VideoEntryForm';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Admin paneli için ana route */}
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Admin />} />  {/* Varsayılan olarak Admin sayfası */}
          <Route path="afis-olustur" element={<AfisOlustur />} />
          <Route path="blog-duzenle" element={<BlogDuzenle />} />
          <Route path="blog-ekle" element={<BlogEkle />} />
          <Route path="kategori-ekle" element={<KategoriEkle />} />
          <Route path="kullanici-duzenle" element={<KullaniciDuzenle />} />
          <Route path="kullanici-ekle" element={<KullaniciEkle />} />
          <Route path="afis-duzenle" element={<AfisDuzenle />} />
          <Route path="portfolyo-ekle" element={<PortfolyoEkle/>} />
          <Route path="work-hours" element={<WorkHoursPanel />} />
          <Route path="yemek-listesi-ekle" element={<YemekListesiEkle />} />
          <Route path="yemek-listesi-duzenle" element={<YemekListesiDuzenle />} />
          <Route path="video-ekle" element={<VideoEntryForm />} />
        </Route>

        {/* Login sayfası */}
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
